import { useState, useEffect, useRef } from 'react';
import dayjs from 'dayjs';  // Import dayjs
import timezone from 'dayjs/plugin/timezone';  // Import timezone plugin
import utc from 'dayjs/plugin/utc';  // Import UTC plugin
import { Postdata } from '../../../helpers/api.service';
import HttpService from '../../../helpers/httpServices';
import { message } from '../../../redux/actions/toastActions';
import { useDispatch, useSelector } from 'react-redux';
import Select from "react-select"
import { isPermission, isRole } from '../../../redux/selectors/authSelector';

// Extend dayjs with the plugins
dayjs.extend(timezone);
dayjs.extend(utc);

function generateYear(year) {
  return Array.from({ length: 12 }, (_, month) => {
    const firstDay = new Date(year, month, 1);
    const days = [];
    const start = new Date(firstDay);
    start.setDate(1 - start.getDay());
    for (let i = 0; i < 42; i++) {
      const date = new Date(start);
      date.setDate(start.getDate() + i);
      days.push({
        date,
        isToday: date.toDateString() === new Date().toDateString(),
        isCurrentMonth: date.getMonth() === month,
      });
    }
    return {
      name: firstDay.toLocaleString('default', { month: 'long' }),
      days,
    };
  });
}

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default function YearView({ currentDate }) {
  const [year, setYear] = useState(new Date().getFullYear());
  const [months, setMonths] = useState(generateYear(year));
  const [tooltipEvents, setTooltipEvents] = useState([]);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
  const [tooltipDate, setTooltipDate] = useState(null);
  const [eventDetailsTooltip, setEventDetailsTooltip] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [editingIndex, setEditingIndex] = useState(null);
  const [formData, setFormData] = useState({ id: null, title: '', notes: '', start_time: '', end_time: '', place: '', members: [], board_members: [], color: '#facc15' });
  const [events, setEvents] = useState({});
  const [showColorPicker, setShowColorPicker] = useState(false);
  const hideTimer = useRef(null);
  const tooltipRef = useRef(null);
  const dispatch = useDispatch()
  const eventDetailsTooltipRef = useRef(null);
  const [refresh, setRefresh] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [member, setMember] = useState([])
  const [boardMember, setBoardMember] = useState([]);
      const permissions = useSelector(isPermission);
    const role = useSelector(isRole)
    console.log("permissions", permissions)
    const addPermission = role == "schooladmin" || permissions && permissions?.includes('edit_Education') || false;
    const deletePermission = role == "schooladmin" || permissions && permissions?.includes('delete_Education') || false;

  useEffect(() => {
    const year = currentDate.year();
    const generatedMonths = generateYear(year);
    setMonths(generatedMonths);
  }, [currentDate]);
  useEffect(() => {
    setMonths(generateYear(year));

    // Event listener to close the tooltip if clicked outside
    const handleOutsideClick = (event) => {
      if (
        tooltipRef.current && !tooltipRef.current.contains(event.target) &&
        eventDetailsTooltipRef.current && !eventDetailsTooltipRef.current.contains(event.target)
      ) {
        setTooltipEvents([]);
        setTooltipDate(null);
        setEventDetailsTooltip(null);  // Close event details tooltip
      }
    };

    // Add event listener when the component is mounted
    document.addEventListener('mousedown', handleOutsideClick);

    // Clean up the event listener when the component is unmounted
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [year]);

  const showTooltip = (dateStr, target) => {
    clearTimeout(hideTimer.current);
    const rect = target.getBoundingClientRect();
    const x = rect.left + rect.width / 2;
    const y = rect.bottom + 8;

    // Calculate available space on the screen
    const spaceRight = window.innerWidth - rect.right;
    const spaceLeft = rect.left;
    const spaceBelow = window.innerHeight - rect.bottom;
    const spaceAbove = rect.top;

    // Adjust horizontal position based on available space
    const adjustedX = spaceRight < 200 ? x - 200 : (spaceLeft < 200 ? x + 200 : x);  // Move tooltip to left or right if space is tight

    // Adjust vertical position based on available space
    const adjustedY = spaceBelow > 150 ? y : (spaceAbove > 150 ? rect.top - 150 : y);  // Move tooltip up or down based on available space

    const formattedDate = dayjs(dateStr).format('YYYY-MM-DD');
    const eventsForDate = events[formattedDate] || [];
    setTooltipDate(formattedDate);
    setTooltipPosition({ x: adjustedX, y: adjustedY });
    setTooltipEvents(eventsForDate.map((event, i) => ({ ...event, _index: i, date: formattedDate })));
  };

  // const delayedHideTooltip = () => {
  //   hideTimer.current = setTimeout(() => {
  //     setTooltipEvents([]);
  //     setTooltipDate(null);
  //   }, 300);
  // };

  const handleDelete = (id) => {
    setIsLoading(true)
    Postdata(HttpService.calendar_event_delete, { id }).then((response) => {
      setRefresh(!refresh)
      dispatch(message(response.message))
      setEventDetailsTooltip(null)
      setTooltipEvents(tooltipEvents.filter((event) => event._id !== id));
    })

  }

  const showEventDetailsTooltip = (event, target) => {
    console.log("event>>>>>>", event)
    setEventDetailsTooltip(event);  // Store the clicked event details to display in the detailed tooltip

    const rect = target.getBoundingClientRect();
    const spaceAbove = rect.top;
    const spaceBelow = window.innerHeight - rect.bottom;

    const tooltipX = rect.left + rect.width / 2 - 160;
    const tooltipY = spaceBelow > 150 ? rect.bottom + 8 : rect.top - 200;

    // Adjust the X position if there's not enough space on the right
    const spaceRight = window.innerWidth - rect.right;
    const adjustedX = spaceRight < 200 ? tooltipX - 200 : tooltipX;

    setTooltipPosition({
      x: adjustedX,
      y: tooltipY,
    });
  };

  const closeEventDetailsTooltip = () => {
    setEventDetailsTooltip(null);  // Close the event details tooltip
  };

  const openEditModal = (event, index) => {
    setFormData({ ...event, id: event._id })

    setEditingIndex(index);
    setModalOpen(true);
  };

  const fetchBoardMember = () => {
    setIsLoading(true)
    Postdata(HttpService.board_management_list).then((response) => {
      if (response.status === 200) {
        setBoardMember(response.data.boards)
        setIsLoading(false)
      } else {
        setIsLoading(false)
        dispatch(message(response.message))
      }
    })
  }
  const fetchMembers = () => {
    setIsLoading(true)
    Postdata(HttpService.school_management_list).then((response) => {
      if (response.status === 200) {
        setMember(response.data.managers)
        setIsLoading(false)
      } else {
        setIsLoading(false)
        dispatch(message(response.message))
      }
    })
  }


  const handleBoardMemberChange = (selected) => {
    const selectedNames = selected ? selected.map((item) => item.value) : [];
    setFormData({ ...formData, board_members: selectedNames });
  }

  const handleMemberChange = (selected) => {
    const selectedNames = selected ? selected.map((item) => item.value) : [];
    setFormData({ ...formData, members: selectedNames });
  }


  const handleSaveEvent = () => {
    const updated = { ...events };

    // // Convert the selected date to local time using dayjs
    // const localDate = dayjs(formData.date).tz(dayjs.tz.guess()).format();  // Get local time in ISO format

    // if (!updated[localDate]) updated[localDate] = [];

    // if (editingIndex !== null) {
    //   updated[localDate][editingIndex] = { ...formData, date: localDate };
    // } else {
    //   updated[localDate].push({ ...formData, date: localDate });
    // }

    // localStorage.setItem('calendarEvents', JSON.stringify(updated));
    // setEvents(updated);
    // setModalOpen(false);
    // setEditingIndex(null);

      if (
        dayjs(`${formData.date}T${formData.end_time}`).isBefore(
          dayjs(`${formData.date}T${formData.start_time}`)
        )
      ) {
        dispatch(message('End time should be greater than Start time'));
        return; // stop submitting
      }

    const payload = {
      title: formData.title,
      place: formData.place,
      notes: formData.notes,
      date: formData.date,
      start_time: formData.start_time,
      end_time: formData.end_time,
      members: Array.isArray(formData.members) ? formData.members : [],
      board_members: Array.isArray(formData.board_members) ? formData.board_members : [],
      color: formData.color,
    };
    if (formData.id) {
      payload.id = formData.id
    }

    console.log("payload.id>>>>>>>>>>>", payload.id)

    setIsLoading(true)
    Postdata(HttpService.calendar_event_add, payload).then((response) => {
      if (response.status === 200) {

        const savedEvent = {
          ...response.data,
          _start: dayjs(`${dayjs(response.data.date).format("YYYY-MM-DD")}T${response.data.start_time}`),
          _end: dayjs(`${dayjs(response.data.date).format("YYYY-MM-DD")}T${response.data.end_time}`),
        };

        const dateKey = dayjs(savedEvent.date).format("YYYY-MM-DD");

        setEvents(prev => ({
          ...prev,
          [dateKey]: prev[dateKey] ? [...prev[dateKey], savedEvent] : [savedEvent],
        }));
        setRefresh(!refresh)
        setModalOpen(false);
        setEditingIndex(null);
        setEventDetailsTooltip(null);

      } else {
        dispatch(message(response.message));
      }
    })
  };

  const fetchEvents = () => {
    setIsLoading(true)
    Postdata(HttpService.calendar_event_list).then((response) => {
      if (response.status === 200) {
        const grouped = {};
        response.data.forEach(event => {
          const dateKey = dayjs(event.date).format("YYYY-MM-DD");
          if (!grouped[dateKey]) grouped[dateKey] = [];
          grouped[dateKey].push({
            ...event,
            _start: dayjs(`${dateKey}T${event.start_time}`),
            _end: dayjs(`${dateKey}T${event.end_time}`),
          });
        });
        console.log("grouped>>>>>>>>>>", grouped)
        setEvents(grouped);
        setIsLoading(false)
      } else {
        setIsLoading(false)
        dispatch(message(response.message))
      }
    })
  }

  useEffect(() => {
    fetchEvents()
  }, [refresh])


  useEffect(() => {
    fetchEvents()
    fetchMembers()
    fetchBoardMember()
  }, [])



  return (
    <div className="p-4 relative">
      {/* <header className="flex items-center justify-between border-b border-gray-200 px-6 py-4">
        <div className="flex items-center gap-4">
          <button onClick={() => setYear((y) => y - 1)} className="rounded-md bg-gray-100 px-2 py-1 text-sm text-gray-700 hover:bg-gray-200">❮ Prev</button>
          <h1 className="text-base font-semibold leading-6 text-gray-900">{year}</h1>
          <button onClick={() => setYear((y) => y + 1)} className="rounded-md bg-gray-100 px-2 py-1 text-sm text-gray-700 hover:bg-gray-200">Next ❯</button>
        </div>
        <button onClick={() => setYear(new Date().getFullYear())} className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500">Today</button>
      </header> */}

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 mt-6">
        {months.map((month, idx) => (
          <div key={idx} className="text-sm">
            <h3 className="font-semibold text-gray-800 mb-2 text-center">{month.name}</h3>
            <div className="grid grid-cols-7 text-xs text-center text-gray-500 mb-1">
              {['S', 'M', 'T', 'W', 'T', 'F', 'S'].map((d) => (
                <div>{d}</div>
              ))}
            </div>
            <div className="grid grid-cols-7 text-xs text-center">
              {month.days.map((day, i) => {
                const dateStr = dayjs(day.date).format('YYYY-MM-DD');
                const dayEvents = events[dateStr] || [];
                return (
                  <div
                    key={i}
                    className="p-1 relative"
                    onClick={(e) => showTooltip(dateStr, e.currentTarget)}
                  >
                    <div
                      className={classNames(
                        'h-6 w-6 mx-auto flex items-center justify-center rounded',
                        day.isToday && 'bg-blue-200',
                        !day.isCurrentMonth && 'text-gray-300',
                        day.isCurrentMonth && 'hover:bg-gray-100 cursor-pointer'
                      )}
                    >
                      {day.date.getDate()}
                    </div>
                    {dayEvents.length > 0 && (
                      <span className="block w-1 h-1 rounded-full mx-auto mt-0.5" style={{ backgroundColor: dayEvents[0].color }}></span>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>

      {tooltipEvents.length > 0 && tooltipDate && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-[1px]">
    <div className="bg-white rounded-2xl shadow-2xl p-6 w-full max-w-md max-h-[80vh] overflow-y-auto relative">
      <button
        onClick={() => {
          setTooltipEvents([]);
          setTooltipDate(null);
        }}
        className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
        aria-label="Close"
      >
        <svg className="h-6 w-6" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>

      <h2 className="text-xl font-semibold mb-4 text-gray-800 text-center">
        Events on {dayjs(tooltipDate).format('MMMM D, YYYY')}
      </h2>

      {tooltipEvents.map((event, idx) => (
        <div
          key={idx}
          className="border border-gray-200 rounded-lg p-4 shadow-sm hover:shadow transition-shadow bg-gray-50 mb-4"
        >
          <div className="flex justify-between items-start">
            <div className="space-y-1 text-xs text-gray-700 w-[75%]">
              <p className="text-base font-semibold text-gray-800">{event.title}</p>
              <p>{dayjs(`${event.date}T${event.start_time}`).format('dddd, MMM D')}</p>
              <p>
                {dayjs(`${event.date}T${event.start_time}`).format('h:mm A')} –{' '}
                {dayjs(`${event.date}T${event.end_time}`).format('h:mm A')}
              </p>
              {event.place && (
                <p>📍 <span className="font-medium">{event.place}</span></p>
              )}
              {event.members?.length > 0 && (
                <p>👥 <span className="font-medium">Members:</span>{" "}
                  {member.filter(m => event.members.includes(m._id)).map(m => m.name).join(", ")}
                </p>
              )}
              {event.board_members?.length > 0 && (
                <p>🪑 <span className="font-medium">Board:</span>{" "}
                  {boardMember.filter(b => event.board_members.includes(b._id)).map(b => b.name).join(", ")}
                </p>
              )}
              {event.notes && (
                <p>📝 <span className="font-medium">Notes:</span> {event.notes}</p>
              )}
            </div>
            <div className="flex flex-col gap-2 items-end text-xs">
             {addPermission && <button
                onClick={() => {
                  openEditModal(event, idx);
                  setTooltipEvents([]);
                  setTooltipDate(null);
                }}
                className="text-indigo-600 hover:underline"
              >
                Edit
              </button>}
             {deletePermission && <button
                onClick={() => handleDelete(event._id)}
                className="text-red-600 hover:underline"
              >
                Delete
              </button>}
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
)}


      {eventDetailsTooltip && (
        <div
          ref={eventDetailsTooltipRef}
          className="fixed z-50 bg-white rounded-md shadow-lg p-6 text-sm border w-80"
          style={{
            top: tooltipPosition.y,
            left: tooltipPosition.x,
            transform: 'translate(-50%, 0)',
          }}
        >
          {/* Close button */}
          <button
            onClick={closeEventDetailsTooltip}
            className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="h-5 w-5">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>

          <h4 className="text-lg font-semibold text-gray-800">{eventDetailsTooltip.title}</h4>
          <div className="text-xs text-gray-600 mb-2">
            <p><strong>Time:</strong> {eventDetailsTooltip.start_time} - {eventDetailsTooltip.end_time}</p>
            <p><strong>Place:</strong> {eventDetailsTooltip.place}</p>
            {eventDetailsTooltip.members && eventDetailsTooltip.members.length > 0 && (
              <p><strong>Members:</strong> {member
                .filter(m => eventDetailsTooltip.members.includes(m._id))
                .map(m => m.name)
                .join(", ")}</p>
            )}
            {eventDetailsTooltip.board_members && eventDetailsTooltip.board_members.length > 0 && (
              <p><strong>Board Members:</strong> {boardMember
                .filter(m => eventDetailsTooltip.board_members.includes(m._id))
                .map(m => m.name)
                .join(", ")}</p>
            )}
            <p><strong>Notes:</strong> {eventDetailsTooltip.notes}</p>
          </div>
          {eventDetailsTooltip.notes && <p><strong>Notes:</strong> {eventDetailsTooltip.notes}</p>}
          <div className="mt-3 flex gap-2 justify-end">
            <button
              onClick={() => openEditModal(eventDetailsTooltip, eventDetailsTooltip._index)}
              className="text-xs text-indigo-600 hover:underline"
            >
              Edit
            </button>
            <button onClick={() => handleDelete(eventDetailsTooltip._id)} className="text-xs text-indigo-600 hover:underline">Delete</button>
          </div>
        </div>
      )}


      {modalOpen && addPermission &&(
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-25">
          <div className="bg-white rounded-2xl shadow-xl p-6 w-full max-w-md space-y-4 relative"> {/* Add relative positioning here */}

            {/* Close button */}
            <button
              onClick={() => setModalOpen(false)}
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 z-10"
            >
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="h-5 w-5">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>

            <div className="flex justify-between items-center">
              <input
                type="text"
                placeholder="Event Title"
                className="text-lg font-semibold w-full outline-none"
                value={formData.title}
                onChange={(e) => setFormData({ ...formData, title: e.target.value })}
              />
              <div className="relative ml-3">
                <button
                  className="w-10 h-6 flex items-center justify-center rounded-full border bg-white shadow"
                  onClick={() => setShowColorPicker(!showColorPicker)}
                >
                  <span className="w-3 h-3 rounded-full" style={{ backgroundColor: formData.color }} />
                </button>
                {showColorPicker && (
                  <div className="absolute right-0 mt-2 bg-white p-2 rounded shadow grid gap-2 z-10">
                    {['#f87171', '#facc15', '#4ade80', '#60a5fa', '#a78bfa', '#f472b6'].map((color) => (
                      <button
                        key={color}
                        onClick={() => {
                          setFormData({ ...formData, color });
                          setShowColorPicker(false);
                        }}
                        className="w-5 h-5 rounded-full"
                        style={{ backgroundColor: color }}
                      />
                    ))}
                  </div>
                )}
              </div>
            </div>

            <div className="grid grid-cols-2 gap-3">
              <input
                type="date"
                className="w-full border rounded px-3 py-2 outline-none"
                value={formData.date}
                onChange={(e) => setFormData({ ...formData, date: e.target.value })}
              />
              <input
                type="time"
                className="w-full border rounded px-3 py-2 outline-none"
                value={formData.start_time}
                onChange={(e) => setFormData({ ...formData, start_time: e.target.value })}
              />
              <input
                type="time"
                className="w-full border rounded px-3 py-2 outline-none"
                value={formData.end_time}
                onChange={(e) => setFormData({ ...formData, end_time: e.target.value })}
              />
            </div>

            <input
              type="text"
              placeholder="Place"
              className="w-full border rounded px-3 py-2 outline-none"
              value={formData.place}
              onChange={(e) => setFormData({ ...formData, place: e.target.value })}
            />
            <Select
              isMulti
              name="members"
              options={member.map((m) => ({ value: m._id, label: m.name }))}
              value={formData.members && formData.members.map((id) => ({
                value: id,
                label: member.find((m) => m._id === id).name
              }))}
              onChange={handleMemberChange}
            />

            <Select
              isMulti
              name="board members"
              options={boardMember.map((m) => ({ value: m._id, label: m.name }))}
              value={formData.board_members && formData.board_members.map((id) => ({
                value: id,
                label: boardMember.find((m) => m._id === id).name
              }))}
              onChange={handleBoardMemberChange}
            />
            <textarea
              placeholder="Notes"
              className="w-full border rounded px-3 py-2 outline-none"
              rows={2}
              value={formData.notes}
              onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
            />

            <div className="flex justify-end space-x-2 pt-2">
              <button
                onClick={() => setModalOpen(false)}
                className="px-4 py-2 rounded bg-gray-100 hover:bg-gray-200"
              >
                Cancel
              </button>
              <button
                onClick={handleSaveEvent}
                className="px-4 py-2 rounded bg-indigo-600 text-white hover:bg-indigo-700"
              >
                {editingIndex !== null ? 'Update' : 'Save'}
              </button>
            </div>
          </div>
        </div>
      )}


    </div>
  );
}
